/**
 * @file
 * Shared utility functions for the layerone theme.
 *
 * This file must load before the other global.*.js files, since they
 * reference Drupal.layerone.getScreenWidth().
 */
(function ($, Drupal) {

  'use strict';

  Drupal.layerone = Drupal.layerone || {};

  // Screen width, adjusted for Safari's extra 15px scrollbar allowance.
  Drupal.layerone.getScreenWidth = function () {
    let hasSafariBrowser = window.matchMedia(`screen and (max-width: ${window.innerWidth - 15}px)`).matches;
    let screenWidth = window.innerWidth;
    if (hasSafariBrowser) {
      screenWidth = screenWidth - 15;
    }
    return screenWidth;
  };

})(jQuery, Drupal);
